import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { RadioButton } from '@lt/components';
import { FatBlockContainer } from './ContentContainer';

const ShippingType = ({
  deliveryMethods,
  value: selectedValue,
  onChange,
  isMobile,
  disabled,
}) => {
  const Wrapper = isMobile ? FatBlockContainer : React.Fragment;
  return (
    <Wrapper>
      <StyledContainer isMobile={isMobile}>
        {deliveryMethods.map(({ label, value }) => {
          const elId = `delivery-method-${value}`;
          const selected = value === selectedValue;
          return (
            <StyledLabel
              key={elId}
              id={`${value}-label`}
              htmlFor={elId}
              selected={selected}
            >
              <RadioButton
                id={elId}
                name={elId}
                value={value}
                checked={selected}
                disabled={disabled}
                onChange={() => onChange(value)}
              />
              {label}
            </StyledLabel>
          );
        })}
      </StyledContainer>
    </Wrapper>
  );
};

ShippingType.propTypes = {
  deliveryMethods: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    }),
  ).isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  isMobile: PropTypes.bool,
  disabled: PropTypes.bool,
};
ShippingType.defaultProps = {
  isMobile: false,
  disabled: false,
};

const StyledContainer = styled.div`
  display: flex;
  flex-flow: column;

  ${(props) =>
    props.isMobile &&
    css`
      padding: 10px;
      border-radius: 6px;
      box-shadow: 0 10px 15px 0 rgba(216, 214, 204, 0.9),
        0 1px 2px 0 rgba(210, 208, 197, 0.9);
    `};
`;
const StyledLabel = styled.label`
  margin-bottom: 15px;
  font-size: 16px;
  color: ${({ theme }) => theme.colors.blackBase};
  cursor: pointer;

  ${(props) =>
    props.selected &&
    css`
      font-weight: 500;
    `};

  input {
    margin-right: 7px;
    display: inline-block;
    border: none;
  }
`;

export default ShippingType;
